import React from 'react';
import { components } from 'react-select';
import classNames from 'classnames';
import BaseOption from '../components/base-option';
const renderOption = (Component = BaseOption) => {
  const Option = components.Option;
  const OptionWrapper = (optionProps) => {
    const { data, ...restProps } = optionProps;
    const {
      selectProps: { isTouchDevice: touchDevice, shouldMarkSelectedOption },
    } = optionProps;
    const classes = classNames({
      'ws-ui-base-select__option--is-touch-device': touchDevice,
      'ws-ui-base-select__option--not-marked-selected': !shouldMarkSelectedOption,
    });

    return (
      <Option {...optionProps} data={data} isDisabled={!!data.disabled} className={classes}>
        <div className="ws-ui-base-select__option-content">
          <Component {...data} {...restProps} />
        </div>
      </Option>
    );
  };

  OptionWrapper.displayName = 'OptionWrapper';

  return OptionWrapper;
};

export default renderOption;
